import { useCallback, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { refreshNotificationInbox } from "../helpers/notifications"

/**
 * Header notification badge + dropdown state.
 * Loads once after login and on explicit sync (dropdown open / mark read).
 * Foreground push updates are handled in App.js via refreshNotificationInbox.
 */
const useNotificationInbox = () => {
  const dispatch = useDispatch()
  const isAuth = useSelector(state => state.auth.isAuth)
  const currentUserId = useSelector(state => state.auth.currentUser?.id)
  const unreadCount = useSelector(state => state.notifications?.unreadCount || 0)
  const items = useSelector(state => state.notifications?.latestUnread || [])

  const sync = useCallback(() => {
    if (!isAuth) return undefined
    return refreshNotificationInbox(dispatch, { userId: currentUserId })
  }, [currentUserId, dispatch, isAuth])

  useEffect(() => {
    if (!isAuth) return undefined
    sync()
    return undefined
  }, [isAuth, sync])

  return { items, unreadCount, sync }
}

export default useNotificationInbox
